import * as types from './types';
import { loading, error } from 'State/actions';

export const getOrderingItemForCurrentSite = currentSite => {
  return async (dispatch, getState, MPWWebApi) => {
    dispatch(loading(types.SITESETUP_ASSIGN_ITEMS_LOADING, true));

    try {
      const response = await MPWWebApi.postGenericInsertUpdate(
        'InvItemSite/GetOrderingItems',
        {
          SiteId: currentSite.Id,
          GrpBidId: 0,
          GrpCatId: 0,
          GrpItemId: 0,
          VendorId: 0,
          StorageLocationId: 0,
          OrderPreferenceId: currentSite.OrderPreferenceId,
        }
      );
      dispatch({
        type: types.SITESETUP_ASSIGN_ORDERING_ITEMS_DATA,
        payload: response,
      });
    } catch (ex) {
      dispatch(error(types.SITESETUP_ASSIGN_ITEMS_DATA_ERROR, ex));
    } finally {
      dispatch(loading(types.SITESETUP_ASSIGN_ITEMS_LOADING, false));
    }
  };
};
export const getBidGroupForCurrentSite = bidEnum => {
  return async (dispatch, getState, MPWWebApi) => {
    dispatch(loading(types.SITESETUP_ASSIGN_ITEMS_LOADING, true));

    try {
      const response = await MPWWebApi.getGeneric(
        `InvGroup/GetBidsGroup/${bidEnum}`
      );
      dispatch({
        type: types.SITESETUP_ASSIGN_ITEMS_BIDGROUP,
        payload: response,
      });
    } catch (ex) {
      dispatch(error(types.SITESETUP_ASSIGN_ITEMS_BIDGROUP_ERROR, ex));
    } finally {
      dispatch(loading(types.SITESETUP_ASSIGN_ITEMS_LOADING, false));
    }
  };
};

export const getItemGroupForCurrentSite = () => {
  return async (dispatch, getState, MPWWebApi) => {
    dispatch(loading(types.SITESETUP_ASSIGN_ITEMS_LOADING, true));

    try {
      const response = await MPWWebApi.getGeneric('InvGroup/GetItemsGroup');
      dispatch({
        type: types.SITESETUP_ASSIGN_ITEMS_ITEMGROUP,
        payload: response,
      });
    } catch (ex) {
      dispatch(error(types.SITESETUP_ASSIGN_ITEMS_ITEMGROUP_ERROR, ex));
    } finally {
      dispatch(loading(types.SITESETUP_ASSIGN_ITEMS_LOADING, false));
    }
  };
};

export const getAcctCategoryForCurrentSite = () => {
  return async (dispatch, getState, MPWWebApi) => {
    dispatch(loading(types.SITESETUP_ASSIGN_ITEMS_LOADING, true));

    try {
      const response = await MPWWebApi.getGeneric(
        'InvGroup/GetAccountCategory/0'
      );
      dispatch({
        type: types.SITESETUP_ASSIGN_ITEMS_ACCT_CATEGORY,
        payload: response,
      });
    } catch (ex) {
      dispatch(error(types.SITESETUP_ASSIGN_ITEMS_ACCT_CATEGORY_ERROR, ex));
    } finally {
      dispatch(loading(types.SITESETUP_ASSIGN_ITEMS_LOADING, false));
    }
  };
};

export const getVendorForCurrentSite = () => {
  return async (dispatch, getState, MPWWebApi) => {
    dispatch(loading(types.SITESETUP_ASSIGN_ITEMS_LOADING, true));

    try {
      const response = await MPWWebApi.getGeneric('InvVendors');
      dispatch({
        type: types.SITESETUP_ASSIGN_ITEMS_VENDOR,
        payload: response,
      });
    } catch (ex) {
      dispatch(error(types.SITESETUP_ASSIGN_ITEMS_VENDOR_ERROR, ex));
    } finally {
      dispatch(loading(types.SITESETUP_ASSIGN_ITEMS_LOADING, false));
    }
  };
};

export const getStorageLocationForCurrentSite = () => {
  return async (dispatch, getState, MPWWebApi) => {
    dispatch(loading(types.SITESETUP_ASSIGN_ITEMS_LOADING, true));

    try {
      const response = await MPWWebApi.getGeneric(
        'InvGroup/GetStorageLocations'
      );
      dispatch({
        type: types.SITESETUP_ASSIGN_ITEMS_STORAGE_LOCATION,
        payload: response,
      });
    } catch (ex) {
      dispatch(error(types.SITESETUP_ASSIGN_ITEMS_STORAGE_LOCATION_ERROR, ex));
    } finally {
      dispatch(loading(types.SITESETUP_ASSIGN_ITEMS_LOADING, false));
    }
  };
};

export const updateAssignItemData = (
  fieldName,
  currentRow,
  OrderPreferenceId
) => {
  return {
    type: types.SITESETUP_UPDATE_ASSIGN_ITEMS_DATA,
    payload: { fieldName, currentRow, OrderPreferenceId },
  };
};

export const checkAllAction = (
  columnName,
  checkAll,
  OrderPreferenceId,
  filterValues
) => {
  return {
    type: types.SITESETUP_CHECKALL_ASSIGN_ITEMS_DATA,
    payload: {
      columnName: columnName,
      checkAll: checkAll,
      OrderPreferenceId: OrderPreferenceId,
      filterValues: filterValues,
    },
  };
};

export const saveOrderingItems = (currentSite, items) => {
  return async (dispatch, getState, MPWWebApi) => {
    dispatch({
      type: types.SITESETUP_ASSIGN_ITEMS_BEGIN_SUBMIT,
    });

    try {
      await MPWWebApi.postGenericInsertUpdate(
        `InvItemSite/SaveOrderingItems/${currentSite.Id}`,
        items
      );
      dispatch({
        type: types.SITESETUP_RESET_ASSIGN_AND_MODIFIED_ITEMS,
      });
    } catch (ex) {
      dispatch(error(types.SITESETUP_SAVE_ORDERING_ITEMS_ERROR, ex));
    } finally {
      dispatch({
        type: types.SITESETUP_ASSIGN_ITEMS_END_SUBMIT,
      });
    }
  };
};

export const clearAssignItemsModal = () => {
  return {
    type: types.SITESETUP_RESET_ASSIGN_ITEMS_ON_CLOSE,
  };
};

export const clearSubmitError = () => {
  return {
    type: types.SITESETUP_CLEAR_ASSIGN_ITEMS_ERROR_SUCCESS,
  };
};



// WEBPACK FOOTER //
// ./src/pages/sitesetup/state/assignItems/actions.js